/*
  FATMAN FILMS
  Header behaviour for Horizon
*/

(() => {
  const HEADER_SELECTOR = "#header-component";
  const SCROLL_THRESHOLD = 36;

  function initFatmanHeader() {
    const header = document.querySelector(HEADER_SELECTOR);

    if (!header || header.dataset.fatmanHeaderReady === "true") {
      return;
    }

    header.dataset.fatmanHeaderReady = "true";

    const isHomePage =
      document.body.classList.contains("template-index") ||
      window.location.pathname === "/";

    function updateHeaderState() {
      const isScrolled = window.scrollY > SCROLL_THRESHOLD;

      header.classList.toggle(
        "fm-header-at-top",
        isHomePage && !isScrolled
      );

      header.classList.toggle(
        "fm-header-scrolled",
        !isHomePage || isScrolled
      );
    }

    function updateMenuState() {
      const openDrawer =
        header.querySelector("details[open]") ||
        header.querySelector("[aria-expanded='true'][aria-controls*='menu']");

      document.body.classList.toggle(
        "fm-header-menu-open",
        Boolean(openDrawer)
      );
    }

    updateHeaderState();
    updateMenuState();

    window.addEventListener("scroll", updateHeaderState, {
      passive: true
    });

    window.addEventListener("resize", updateHeaderState, {
      passive: true
    });

    const observer = new MutationObserver(() => {
      updateMenuState();
    });

    observer.observe(header, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["open", "aria-expanded", "class"]
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        document.body.classList.remove("fm-header-menu-open");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initFatmanHeader);
  document.addEventListener("shopify:section:load", initFatmanHeader);

  if (document.readyState === "interactive" || document.readyState === "complete") {
    initFatmanHeader();
  }
})();